import { ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isNil } from "ramda";
import Loading from "~/components/Loading";
import useUser from "~/contexts/user";
import { ROUTE_404, ROUTE_DEFINITIONS } from "~/router/constants";
import { checkHasRequiredFeatureFlagDefined } from "~/router/useVisibleRoutes";

export const ProtectedAppRoute = ({
  permission,
  children,
  path,
}: {
  permission?: string;
  children?: ReactNode;
  path?: keyof typeof ROUTE_DEFINITIONS;
}) => {
  const user = useUser();

  if (!user) {
    // Still loading user details from /me
    // TODO: Improve error handling/messaging if /me ever goes down
    return <Loading />;
  }

  const hasRequiredFeatureFlag =
    path && checkHasRequiredFeatureFlagDefined(ROUTE_DEFINITIONS[path])
      ? ROUTE_DEFINITIONS[path].requiredFeatureFlag
      : true;

  const requiredPermission =
    permission || (path ? ROUTE_DEFINITIONS[path].requiredPermission : null);
  const isMissingRequiredPermission =
    !isNil(requiredPermission) && !user.permissions?.includes(requiredPermission);

  // Route is either disabled via feature flag or user does not have matching permission
  if (!hasRequiredFeatureFlag || isMissingRequiredPermission) {
    return <Navigate to={ROUTE_404} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};
